import { mapValues, keyBy } from 'lodash';

export const DEFAULT_OPTION = [
  { label: 'Uncategorized', value: 'uncategorized' },
];

export const REPLY_STATUS_OPTIONS = [
  { label: 'Interested', value: 'interested' },
  { label: 'Not interested', value: 'not_interested' },
  { label: 'Not now', value: 'not_now' },
  { label: 'Do not contact', value: 'blacklisted' },
  { label: 'Sponsorship', value: 'sponsorship' },
  { label: 'Uncategorized', value: 'uncategorized' },
  { label: 'Bounced', value: 'bounced' },
  { label: 'Auto reply', value: 'auto_reply' },
];

export const EMAIL_VALIDATION_STATUS_OPTIONS = [
  { label: 'Valid', value: 'valid' },
  { label: 'Invalid', value: 'invalid' },
  { label: 'Risky', value: 'accept_all' },
];

export const DELIVERY_STATUS_OPTIONS = [
  { label: 'Opened', value: 'opened' },
  { label: 'Delivered', value: 'delivered' },
  { label: 'Sent', value: 'sent' },
  { label: 'Bounced', value: 'bounced' },
  { label: 'Finished', value: 'finished' },
  { label: 'Opted out', value: 'unsubscribed' },
  { label: 'Auto reply', value: 'auto_reply' },
  { label: 'Marked as finished', value: 'manually_finished' },
  // { label: 'Variable Error', value: 'variable_error' },
];

export const DELIVERY_STATUS_CRITERIA_OPTIONS = [
  { label: 'Is', value: false },
  { label: 'Is not', value: true },
];

export const REPLY_STATUS_LABEL_LOOKUP = {
  ...mapValues(keyBy(REPLY_STATUS_OPTIONS, 'value'), 'label'),
  ...mapValues(keyBy(DELIVERY_STATUS_OPTIONS, 'value'), 'label'),
};

export const REPLY_STATUS_COLORS = {
  interested: 'interested',
  not_interested: 'notInterested',
  not_now: 'notNow',
  blacklisted: 'deliveryStatusBadge',
  sponsorship: 'sponsorship',
  uncategorized: 'uncategorized',
  bounced: 'deliveryStatusBadge',
  auto_reply: 'autoReply',
  manually_finished: 'deliveryStatusBadge',
  finished: 'deliveryStatusBadge',
  opened: 'deliveryStatusBadge',
  sent: 'deliveryStatusBadge',
  delivered: 'deliveryStatusBadge',
  unsubscribed: 'deliveryStatusBadge',
  variable_error: 'deliveryStatusBadge',
};

export const UNKNOWN_CAMPAIGN_OPTION = {
  label: 'Unknown',
  value: 'unknown_campaign',
};

export const ALL_CAMPAIGNS_OPTION = {
  label: 'All',
  value: 'all_campaigns',
};

export const MESSAGE_LABEL_OPTIONS = [
  { label: 'Archived', value: 'archived' },
  { label: 'Unarchived', value: 'unarchived' },
  { label: 'Read', value: 'read' },
  { label: 'Unread', value: 'unread' },
];
